<template>
  <div class="material-analysis-config">
    <div class="main-wrapper" v-if="aiStrategys.length">
      <div class="header-row">
        <el-tabs v-model="activeName" @tab-click="initSettingForm">
          <el-tab-pane v-for="(item, index) in aiStrategys" :name="item.gameName" :label="item.gameName" :key="index"></el-tab-pane>
        </el-tabs>

        <el-button @click="addGameSettingModal = true">+新增游戏</el-button>
      </div>

      <div style="padding-bottom: 20px">
        <ConfigTabContent
          v-for="(item, index) in aiStrategys"
          :key="index"
          :tab-name="item.gameName"
          v-show="activeName === item.gameName"
          ref="configTabContentRef"
        ></ConfigTabContent>
      </div>

      <div class="save-row">
        <el-button type="primary" @click="onGlobalSettingsSave" :loading="submitLoading">保存{{ activeName }}设置</el-button>
      </div>
    </div>
    <div class="main-wrapper empty" v-else>暂无数据</div>

    <el-dialog title="新增游戏配置" :visible.sync="addGameSettingModal" width="420px">
      <el-form>
        <el-form-item label="选项名称" prop="promptName">
          <el-select placeholder="请选择中间件游戏" v-model="middleGame" value-key="id" filterable style="width: 220px">
            <el-option v-for="item in midGames" :key="item.id" :label="item.name" :value="item"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addGameSettingModal = false">取 消</el-button>
        <el-button type="primary" :disabled="!middleGame" @click="onAddGameSettingConfirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, nextTick, computed } from 'vue'
import moment from 'moment'
import { Message } from 'view-design'
import { getAiStrategys, updateAiStrategy, addAiStrategy } from '@/api/tools.model'

import ConfigTabContent from './config-tab/index.vue'
import { initPageData, MID_GAMES } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([MID_GAMES])

const activeName = ref('全局')
const middleGame = ref(null)
const aiStrategys = ref([])
const configTabContentRef = ref([])
const addGameSettingModal = ref(false)
const submitLoading = ref(false)

const midGames = computed(PAGE_REQUIRED_OPTS.MID_GAMES)

const tabIndex = computed(() => aiStrategys.value.findIndex((item) => item.gameName === activeName.value))
function getSettingList() {
  getAiStrategys().then((data) => {
    if (data) {
      aiStrategys.value = data.map((i) => {
        return { ...i, strategies: i.strategies.map((s) => ({ ...s, upTimeStr: moment(s.createTime).format('YYYY-MM-DD HH:mm:ss') })) }
      })
      initSettingForm()
    }
  })
}

getSettingList()

function onAddGameSettingConfirm() {
  const { name, id } = middleGame.value
  aiStrategys.value.push({
    gameName: name,
    mGameId: id,
    isAdd: 1
  })

  middleGame.value = null
  addGameSettingModal.value = false
  activeName.value = name
  initSettingForm()
}

function initSettingForm() {
  nextTick(() => {
    configTabContentRef.value[tabIndex.value].setForm(aiStrategys.value[tabIndex.value])
  })
}

function onGlobalSettingsSave() {
  const tabIdx = tabIndex.value
  const ref = configTabContentRef.value[tabIdx]

  if (ref) {
    const strategies = ref.getForm()
    const { isAdd, ...restSettings } = aiStrategys.value[tabIdx]
    if (!strategies) return
    const gameConfig = {
      ...restSettings,
      strategies
    }

    submitLoading.value = true
    ;(isAdd ? addAiStrategy(gameConfig) : updateAiStrategy(gameConfig))
      .then((data) => {
        if (data) {
          Message.success('保存成功')
          getSettingList()
        }
      })
      .finally(() => {
        submitLoading.value = false
      })
  } else {
    Message.error('保存失败')
  }
}
</script>
<style lang="scss" scoped>
.material-analysis-config {
  height: 100%;
  padding: 0 16px;
  overflow-x: hidden;
  background: #f5f5f5;

  .main-wrapper {
    padding: 0 15px 0px 15px;
    background-color: #fff;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    &.empty {
      text-align: center;
      height: 100%;
      padding: 100px 0;
    }
  }
}

.header-row {
  // text-align: right;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-tabs {
    flex: 1;
  }
  .el-button {
    margin-left: 10px;
    position: relative;
    top: -3px;
  }
}

.save-row {
  text-align: right;
  padding-bottom: 20px;
}
</style>
